import React, { useEffect, useState } from 'react'
import './solar-style.scss'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import CompanyLogo from '../../assets/images/electric-pole.png'
import SolarPanel from '../../assets/images/solar-panel.png'
import Lighting from '../../assets/images/lighting.png'
import Towerg from '../../assets/images/power-tower-g.png'
import Towery from '../../assets/images/power-tower -y.png'
import Towerred from '../../assets/images/cancel (1) 2.svg'
import Gridorange from '../../assets/images/DS1.svg'
import Gridored from '../../assets/images/DS3.svg'
import Medical from '../../assets/images/medical.png'
import Multimeter from '../../assets/images/multimeter.png'
import Pyranometer from '../../assets/images/pyranometer.png'
import Accumulatordas from '../../assets/images/accumulatordas.png'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@mui/material/InputAdornment'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useNavigate } from 'react-router-dom'
import {
  FetchPlantListNew,
  FetchPlantSearchNew,
  FetchDeviceStatusNew,
} from '../../services/api'
import { fetchIssues } from '../IssueManagement/services/issueService'
import BugReportIcon from '@mui/icons-material/BugReport'
import CircularProgress from '@mui/material/CircularProgress'
import useSolarPlantListStyles from './styles.js'
import dayjs from 'dayjs'
import { get } from 'lodash'

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
}

// Helper function to render device status icon
const renderDeviceStatusIcon = (
  deviceStatusForRow,
  deviceStatusLoading,
  plantId
) => {
  if (deviceStatusLoading[plantId]) {
    return <CircularProgress size={20} />
  }

  const overallStatus = deviceStatusForRow?.overallDeviceStatus

  if (overallStatus === 'green') {
    return <RadioButtonCheckedOutlinedIcon className="status-green" />
  } else if (overallStatus === 'red') {
    return <img src={Gridored} alt="GridOred" />
  } else {
    return <img src={Gridorange} alt="GridOrange" />
  }
}

// Helper function to render grid status icon
const renderGridStatusIcon = (
  deviceStatusForRow,
  deviceStatusLoading,
  plantId
) => {
  console.log('Device Status for Row:', deviceStatusForRow)
  console.log('Device Status Loading:', deviceStatusLoading)

  if (deviceStatusLoading[plantId]) {
    return <CircularProgress size={20} />
  }

  const gridStatus = deviceStatusForRow?.gridStatus || 'offline'
  const overallStatus = deviceStatusForRow?.overallDeviceStatus

  console.log('Grid Status:', gridStatus)
  console.log('Overall Status:', deviceStatusForRow)

  // Grid status follows device status logic
  if (overallStatus === 'green' && gridStatus === 'online') {
    return <img src={Towerg} alt="Grid Online" />
  } else if (overallStatus === 'yellow' && gridStatus === 'online') {
    return <img src={Towery} alt="Grid Offline" />
  } else {
    return <img src={Towerred} alt="Grid Offline" />
  }
}

function Row(props) {
  const {
    row,
    onClick,
    updateDeviceStatus,
    deviceStatus,
    deviceStatusLoading,
    issueCounts,
    handleViewIssues,
  } = props
  const [open, setOpen] = React.useState(false)
  const [openInnerRow, setOpenInnerRow] = React.useState(false)
  const [openDialog, setOpenDialog] = React.useState(false)
  const [age, setAge] = React.useState('')
  const [plantData, setPlantData] = React.useState([])

  /*useEffect(() => {
    setPlantData(row?.roofDetails[0])
  }, [])*/

  const handleChange = (event) => {
    setAge(event.target.value)
    setPlantData(event.target.value)
  }

  const handleClick = () => {
    setOpen(!open)
  }

  const handleClose = () => {
    setOpen(!open)
  }

  const handleClickInnerRow = () => {
    setOpenInnerRow(!openInnerRow)
  }

  const handleClickOpen = () => {
    setOpenDialog(!openDialog)
  }

  useEffect(() => {
    if (row?.id) {
      updateDeviceStatus()
    }
  }, [row])

  console.log('Row datasss:', deviceStatus)

  const rowId = row?.plantId?.toString() || row?.id?.toString()
  const deviceStatusForRow = deviceStatus?.[rowId] || {}

  console.log('Row datasss deviceStatusForRow:', deviceStatusForRow)

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell onClick={onClick}>
          <div className="companylogo_bg">
            <img src={CompanyLogo} alt="company" />
          </div>
        </TableCell>
        <TableCell align="left" scope="row" onClick={onClick}>
          {row?.plantName}
        </TableCell>
        <TableCell
          align="left"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {row?.projectCode}
        </TableCell>
        <TableCell align="left">{row?.plantLocation}</TableCell>
        <TableCell align="center">
          {' '}
          <img src={SolarPanel} alt="solar" /> <b>{row?.plantSize}</b>
        </TableCell>
        <TableCell align="center">
          <img src={Lighting} alt="light" />
          <b>
            {row?.totalEToday !== null
              ? parseFloat(row?.totalEToday).toFixed(2)
              : 0}
          </b>
        </TableCell>
        <TableCell align="center" scope="row">
          <b>
            {row?.dailyEnergy !== null
              ? parseFloat(row?.dailyEnergy).toFixed(2)
              : 0}
          </b>
        </TableCell>
        <TableCell align="center" scope="row">
          <b>{row?.yield !== null ? parseFloat(row?.yield).toFixed(2) : 0}</b>
        </TableCell>
        <TableCell align="center">
          <b>{parseFloat(row?.gti).toFixed(2)}</b>
        </TableCell>
        <TableCell align="center">
          <b>{parseFloat(row?.PR).toFixed(2)}</b>
        </TableCell>
        <TableCell align="center">
          <b>
            {parseFloat(row?.CUF).toFixed(2)}
          </b>
        </TableCell>
        <TableCell align="center">
          {renderGridStatusIcon(
            deviceStatusForRow,
            deviceStatusLoading,
            row?.id
          )}
        </TableCell>
        <TableCell align="center">
          <div style={{ display: 'flex' }}>
            <span className="device_status">
              {renderDeviceStatusIcon(
                deviceStatusForRow,
                deviceStatusLoading,
                row?.id
              )}
            </span>{' '}
            <span className="device_status">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={handleClick}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </span>
          </div>
          {/* Show data gap warning if applicable */}
          {/* {deviceStatusForRow?.isDataStale &&
            deviceStatusForRow?.dataGapMinutes && (
              <div className="data-gap-warning">
                Gap: {deviceStatusForRow.dataGapMinutes}m
              </div>
            )} */}
        </TableCell>
        <TableCell align="center">
          <div
            className={`issue_status ${
              issueCounts[row?.id] > 0 ? 'clickable' : ''
            }`}
            onClick={() =>
              issueCounts[row?.id] > 0 &&
              handleViewIssues(row?.id, row?.plantName)
            }
            title={
              issueCounts[row?.id] > 0
                ? `View ${issueCounts[row?.id]} active issues`
                : 'No active issues'
            }
          >
            {issueCounts[row?.id] > 0 ? (
              <BugReportIcon className="issue_icon" />
            ) : null}
            <span className="issue_count">{issueCounts[row?.id] || 0}</span>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={14}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <div className="align_btw">
              {/*<div>
                <FormControl sx={{ m: 1, minWidth: 280 }} size="small">
                  <InputLabel id="demo-select-small-label"></InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={age}
                    onChange={handleChange}
                  >
                    {row?.roofDetails.map((data, Index) => (
                      <MenuItem key={Index} value={data}>
                        Roof {Index + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>*/}
              <div className="align_end">
                <div className="collapse_btn m_rl_8">
                  <img src={Medical} alt="medical" />
                  <span className="inr_txt">
                    {deviceStatusForRow?.devices?.energyMeters || 0}
                  </span>
                </div>
                <div className="collapse_btn m_rl_8">
                  <img src={Multimeter} alt="multimeter" />
                  <span className="inr_txt">
                    {deviceStatusForRow?.devices?.inverters || 0}
                  </span>
                </div>
                <div className="collapse_btn m_rl_8">
                  <img src={Pyranometer} alt="pyranometer" />
                  <span className="inr_txt">
                    {deviceStatusForRow?.devices?.sensors || 0}
                  </span>
                </div>
                <div className="collapse_btn m_rl_8">
                  <img src={Accumulatordas} alt="accumulatordas" />
                  <span className="inr_txt">
                    {deviceStatusForRow?.devices?.dataLoggers || 0}
                  </span>
                </div>
                <div className="m_rl_8">
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={handleClickInnerRow}
                  >
                    {openInnerRow ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </div>
                <div className="m_rl_8 pointer" onClick={onClick}>
                  <FullscreenIcon />
                </div>
                {openDialog ? (
                  <React.Fragment>
                    <Dialog
                      fullWidth={true}
                      maxWidth="lg"
                      open={openDialog}
                      onClose={handleClose}
                      PaperProps={{ sx: { width: '100%', maxWidth: 1920 } }}
                    >
                      <DialogTitle className="align_end">
                        <span className="pointer" onClick={handleClose}>
                          {' '}
                          <CloseIcon />
                        </span>
                      </DialogTitle>
                      <DialogContent>
                        <TableContainer
                          component={Paper}
                          className="collapse_i_table2"
                          sx={{ maxHeight: '400px', overflowY: 'auto' }}
                        >
                          <Table>
                            <TableHead
                              sx={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 1,
                                backgroundColor: '#fff',
                              }}
                            >
                              <TableRow>
                                <TableCell scope="col" />
                                <TableCell align="left" scope="col">
                                  Plant Name
                                </TableCell>
                                <TableCell align="left" scope="col">
                                  Code
                                </TableCell>
                                <TableCell align="left" scope="col">
                                  Plant Location
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  Plant Size (kWp)
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  E. Today (kWh)
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  Yield (kWh/kWp)
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  GdTI (kWh/m2)
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  PR (%)
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  CUF (%)
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  Grid Status
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  Device Status
                                </TableCell>
                                <TableCell align="center" scope="col">
                                  Issues
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <div className="companylogo_bg">
                                    <img src={CompanyLogo} alt="company" />
                                  </div>
                                </TableCell>
                                <TableCell align="left" scope="row">
                                  {row?.plantName}
                                </TableCell>
                                <TableCell align="left">
                                  {row?.projectCode}
                                </TableCell>
                                <TableCell align="left">
                                  {row?.plantLocation}
                                </TableCell>
                                <TableCell align="center">
                                  <img src={SolarPanel} alt="solar" />{' '}
                                  <b>{row?.plantSize}</b>
                                </TableCell>
                                <TableCell align="center">
                                  <img src={Lighting} alt="light" />{' '}
                                  <b>{row?.totalEToday}</b>
                                </TableCell>
                                <TableCell align="center" scope="row">
                                  <b>{parseFloat(row?.yield).toFixed(2)}</b>
                                </TableCell>
                                <TableCell align="center">
                                  <b>{parseFloat(0)}</b>
                                </TableCell>
                                <TableCell align="center">
                                  <b>{parseFloat(0)}</b>
                                </TableCell>
                                <TableCell align="center">
                                  <b>
                                    {parseFloat(
                                      (row?.totalEToday /
                                        (1 * 24 * row?.plantSize)) *
                                        100
                                    ).toFixed(2)}
                                  </b>
                                </TableCell>
                                <TableCell align="center">
                                  {renderGridStatusIcon(
                                    deviceStatusForRow,
                                    deviceStatusLoading,
                                    row?.id
                                  )}
                                </TableCell>
                                <TableCell align="center">
                                  <span className="device_status">
                                    {renderDeviceStatusIcon(
                                      deviceStatusForRow,
                                      deviceStatusLoading,
                                      row?.id
                                    )}
                                  </span>
                                </TableCell>
                                <TableCell align="center">
                                  <div
                                    className={`issue_status ${
                                      issueCounts[row?.id] > 0
                                        ? 'clickable'
                                        : ''
                                    }`}
                                    onClick={() =>
                                      issueCounts[row?.id] > 0 &&
                                      handleViewIssues(row?.id, row?.plantName)
                                    }
                                    title={
                                      issueCounts[row?.id] > 0
                                        ? `View ${
                                            issueCounts[row?.id]
                                          } active issues`
                                        : 'No active issues'
                                    }
                                  >
                                    {issueCounts[row?.id] > 0 ? (
                                      <BugReportIcon className="issue_icon" />
                                    ) : null}
                                    <span className="issue_count">
                                      {issueCounts[row?.id] || 0}
                                    </span>
                                  </div>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <Box className="p15_20">
                          <Grid container spacing={2}>
                            {/*
                            <Grid item xs={12} md={6}>
                              <div>
                                <FormControl
                                  sx={{ m: 1, minWidth: 240 }}
                                  size="small"
                                >
                                  <InputLabel id="demo-select-small-label"></InputLabel>
                                  <Select
                                    labelId="demo-select-small-label"
                                    id="demo-select-small"
                                    value={age}
                                    onChange={handleChange}
                                  >
                                    {row?.roofDetails.map((data, Index) => (
                                      <MenuItem key={Index} value={data}>
                                        Roof {Index + 1}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </div>
                            </Grid>
                            */}
                            <Grid item xs={12} md={6}>
                              <div className="align_end wrap">
                                <div className="collapse_btn m_rl_8">
                                  <img src={Medical} alt="medical" />
                                  <span className="inr_txt">1</span>
                                </div>
                                <div className="collapse_btn m_rl_8">
                                  <img src={Multimeter} alt="multimeter" />
                                  <span className="inr_txt">1</span>
                                </div>
                                <div className="collapse_btn m_rl_8">
                                  <img src={Pyranometer} alt="pyranometer" />
                                  <span className="inr_txt">0</span>
                                </div>
                                <div className="collapse_btn m_rl_8">
                                  <img
                                    src={Accumulatordas}
                                    alt="accumulatordas"
                                  />
                                  <span className="inr_txt">0</span>
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>
                        <div>
                          <TableContainer
                            component={Paper}
                            sx={{ maxHeight: '400px', overflowY: 'auto' }}
                          >
                            <Table className="collapse_i_table">
                              <TableHead
                                sx={{
                                  position: 'sticky',
                                  top: 0,
                                  zIndex: 1,
                                  backgroundColor: '#fff',
                                }}
                              >
                                <TableRow>
                                  <TableCell align="left" scope="col">
                                    Inverter Serial No.
                                  </TableCell>
                                  <TableCell align="left" scope="col">
                                    Make/ Model
                                  </TableCell>
                                  <TableCell align="center" scope="col">
                                    No. of strings
                                  </TableCell>
                                  <TableCell align="center" scope="col">
                                    DC Loading(kW)
                                  </TableCell>
                                  <TableCell align="center" scope="col">
                                    Daily Energy(kWh)
                                  </TableCell>
                                  <TableCell align="center" scope="col">
                                    Total Energy(kWh)
                                  </TableCell>
                                  <TableCell align="center" scope="col">
                                    Yield(kWh/kWp)
                                  </TableCell>
                                  <TableCell align="center" scope="col">
                                    Status
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {plantData &&
                                  plantData?.inverters?.map((plData, index) => (
                                    <TableRow key={index}>
                                      <TableCell align="left">
                                        {plData?.InverterSerialNumber}
                                      </TableCell>
                                      <TableCell align="left">
                                        {plData?.inverterMake ||
                                          plData?.inverterMode}
                                      </TableCell>
                                      <TableCell align="center">
                                        {plData?.noOfStrings}
                                      </TableCell>
                                      <TableCell align="center">
                                        {plData?.dcCapacity}
                                      </TableCell>
                                      <TableCell align="center">
                                        {plData?.dailyEnergy}
                                      </TableCell>
                                      <TableCell align="center">
                                        {plData?.deviceTotalEnergy}
                                      </TableCell>
                                      <TableCell align="center">
                                        {parseFloat(
                                          plData?.dailyEnergy / row?.plantSize
                                        ).toFixed(1)}
                                      </TableCell>
                                      <TableCell align="center">
                                        <span className="device_status">
                                          <RadioButtonCheckedOutlinedIcon />
                                        </span>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </DialogContent>
                    </Dialog>
                  </React.Fragment>
                ) : null}
              </div>
            </div>
            {openInnerRow ? (
              <div>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <TableContainer
                    component={Paper}
                    sx={{ maxHeight: '400px', overflowY: 'auto' }}
                  >
                    <Table
                      aria-label="collapsible table"
                      className="collapse_i_table"
                    >
                      <TableHead
                        sx={{
                          position: 'sticky',
                          top: 0,
                          zIndex: 1,
                          backgroundColor: '#fff',
                        }}
                      >
                        <TableRow>
                          <TableCell align="left" scope="col">
                            Inverter Serial No.
                          </TableCell>
                          <TableCell align="left" scope="col">
                            Make/ Model
                          </TableCell>
                          <TableCell align="center" scope="col">
                            No. of strings
                          </TableCell>
                          <TableCell align="center" scope="col">
                            DC Loading(kW)
                          </TableCell>
                          <TableCell align="center" scope="col">
                            Daily Energy(kWh)
                          </TableCell>
                          <TableCell align="center" scope="col">
                            Total Energy(kWh)
                          </TableCell>
                          <TableCell align="center" scope="col">
                            Yield(kWh/kWp)
                          </TableCell>
                          <TableCell align="center" scope="col">
                            Status
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {plantData &&
                          plantData?.inverters?.map((plData, index) => (
                            <TableRow key={index}>
                              <TableCell align="left">
                                {plData?.InverterSerialNumber}
                              </TableCell>
                              <TableCell align="left">
                                {plData?.inverterMake || plData?.inverterMode}
                              </TableCell>
                              <TableCell align="center">
                                {plData?.noOfStrings}
                              </TableCell>
                              <TableCell align="center">
                                {plData?.dcCapacity}
                              </TableCell>
                              <TableCell align="center">
                                {plData?.dailyEnergy}
                              </TableCell>
                              <TableCell align="center">
                                {plData?.deviceTotalEnergy}
                              </TableCell>
                              <TableCell align="center">
                                {parseFloat(
                                  plData?.dailyEnergy / row?.plantSize
                                ).toFixed(1)}
                              </TableCell>
                              <TableCell align="center">
                                <span className="device_status">
                                  <RadioButtonCheckedOutlinedIcon />
                                </span>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Collapse>
              </div>
            ) : null}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

Row.propTypes = {
  row: PropTypes.shape({
    plantSize: PropTypes.number.isRequired,
    totalEToday: PropTypes.number,
    dailyEnergy: PropTypes.number,
    yield: PropTypes.number,
    gti: PropTypes.number,
    PR: PropTypes.number,
    plantName: PropTypes.string.isRequired,
    projectCode: PropTypes.string.isRequired,
    plantLocation: PropTypes.string.isRequired,
    gridStatus: PropTypes.string,
    /*roofDetails: PropTypes.arrayOf(
      PropTypes.shape({
        energyMeters: PropTypes.array,
        inverters: PropTypes.array,
        pyranoMeter: PropTypes.array,
      })
    ),*/
    _count: PropTypes.shape({
      energyMeters: PropTypes.number,
      inverters: PropTypes.number,
      sensors: PropTypes.number,
      dataLoggers: PropTypes.number,
      mountingZones: PropTypes.number,
    }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  updateDeviceStatus: PropTypes.func.isRequired,
  deviceStatus: PropTypes.object,
  deviceStatusLoading: PropTypes.object,
}

const SolarPlantList = () => {
  const classes = useSolarPlantListStyles()
  const navigate = useNavigate()
  const [plantlist, sePlantlist] = React.useState([])
  const [sortDate, setSortDate] = React.useState(dayjs(new Date()))
  const [deviceStatus, setDeviceStatus] = React.useState({})
  const [deviceStatusLoading, setDeviceStatusLoading] = React.useState({})
  const [selectedValue, setSelectedValue] = useState('')
  const [searchName, setSearchName] = useState('')
  const [Loading, setLoading] = useState(true)
  const [plantSizeOrder, setPlantSizeOrder] = useState(true)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const headerRef = React.useRef(null)
  const [headerHeight, setHeaderHeight] = useState(200)
  const [issueCounts, setIssueCounts] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const token = localStorage.getItem('accessToken')


  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight)
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight)
      }
    }
    window.addEventListener('resize', handleResize)
    handleResize() // Initial call to set header height
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value)
  }

  const handleSearch = (e) => {
    setSearchName(e.target.value)
  }

  const handleTechnicalView = (data) => {
    const deviceStatusForPlant = deviceStatus[data?.id]?.data || {};
    console.log("deviceStatusForPlant?.devices?.inverters", deviceStatusForPlant)
    navigate('/TechnicalView', {
      state: {
        data,
        token: token,
        selectedDate: dayjs(sortDate).format('DD-MM-YYYY'),
        totalEToday:
          data?.totalEToday !== null
            ? parseFloat(data?.totalEToday).toFixed(2)
            : 0,
        dailyEnergy:
          data?.dailyEnergy !== null
            ? parseFloat(data?.dailyEnergy).toFixed(2)
            : 0,
        deviceCounts: {
          inverters: deviceStatusForPlant?.devices?.inverters ?? 0,
          energyMeters: deviceStatusForPlant?.devices?.energyMeters ?? 0,
          sensors: deviceStatusForPlant?.devices?.sensors ?? 0,
          dataLoggers: deviceStatusForPlant?.devices?.dataLoggers ?? 0,
        }
      },
    })
    console.log("Set state 🟢🟢🔰", {
      data,
      token: token,
      selectedDate: dayjs(sortDate).format('DD-MM-YYYY'),
      totalEToday:
        data?.totalEToday !== null
          ? parseFloat(data?.totalEToday).toFixed(2)
          : 0,
      dailyEnergy:
        data?.dailyEnergy !== null
          ? parseFloat(data?.dailyEnergy).toFixed(2)
          : 0,
      deviceCounts: data?._count || {
        inverters: 0,
        energyMeters: 0,
        sensors: 0,
        dataLoggers: 0,
        mountingZones: 0
      }
    });
  }

  const handleAddnewplant = () => {
    navigate('/addnewplant', { state: { token: token } })
  }
  const handleSolarMapView = () => {
    navigate('/SolarMapView')
  }

  const handleADDdevice = () => {
    navigate('/Devicelist', { state: { plantlist, token: token } })
  }

  const handlePlantreport = () => {
    navigate('/plantreport', { state: { plantlist, token: token } })
  }

  useEffect(() => {
    const Order = plantSizeOrder === true ? '1' : '-1'
    FetchPlantListNew(dayjs(sortDate).format('YYYY-MM-DD'), token, Order, 100, 0).then(
      (resp) => {
        if (resp?.data) {
          sePlantlist(resp?.data?.data)
          console.log('PlantList:', resp?.data?.data)
          localStorage.setItem('Authorised', true)
          setLoading(false)
        } else {
          localStorage.setItem('Authorised', false)
        }
      }
    )
  }, [])

  useEffect(() => {
    const Order = plantSizeOrder === true ? '1' : '-1'
    FetchPlantSearchNew(
      dayjs(sortDate).format('YYYY-MM-DD'),
      searchName,
      selectedValue,
      token,
      Order,
      100,
      0
    ).then((resp) => {
      if (resp?.data) {
        sePlantlist(resp?.data?.data)
        setLoading(false)
      }
    })
  }, [searchName, selectedValue, plantSizeOrder])

  const HandleSortPlant = () => {
    setPlantSizeOrder(!plantSizeOrder)
  }

  const loadIssueCounts = async () => {
    try {
      const issues = await fetchIssues()
      const counts = {}

      issues.forEach((issue) => {
        if (['Open', 'Under Review', 'Material Awaited', 'OEM', 'In Progress', 'Resolved'].includes(issue.status)) {
          counts[issue.plantId] = (counts[issue.plantId] || 0) + 1
        }
      })

      setIssueCounts(counts)
    } catch (error) {
      console.error('Error loading issue counts:', error)
    }
  }

  const handleViewIssues = (plantId, plantName) => {
    navigate(
      `/issue-management?plantId=${plantId}&plantName=${encodeURIComponent(
        plantName
      )}`
    )
  }

  useEffect(() => {
    loadIssueCounts()
    // Refresh issue counts every 5 minutes
    const intervalId = setInterval(loadIssueCounts, 300000)
    return () => clearInterval(intervalId)
  }, [])

  const handleChangeDate = (value) => {
    const Order = plantSizeOrder === true ? '1' : '-1'
    setSortDate(value)
    FetchPlantListNew(dayjs(value).format('YYYY-MM-DD'), token, Order, 100, 0).then(
      (resp) => {
        if (resp?.data) {
          sePlantlist(resp?.data?.data)
        }
      }
    )
  }

  const updateDeviceStatus = (plantId) => {
    console.log('Updating device status for plantId:', plantId);
    
    if(!plantId || plantId == "undefined" ) {
      console.warn("PlantID is undefined");
      return;
    }
    setDeviceStatusLoading((prev) => ({ ...prev, [plantId]: true }))
    FetchDeviceStatusNew(plantId, token)
      .then((resp) => {
        if (resp?.data) {
          console.log('Device status for plantId:', plantId, resp?.data?.data)

          setDeviceStatus((prevStatuses) => ({
            ...prevStatuses,
            [plantId]: resp?.data?.data,
          }))
        }
        console.log('deviceStatus', deviceStatus)
      })
      .catch((error) => {
        console.error('Error fetching device status:', error)
      })
      .finally(() => {
        setDeviceStatusLoading((prev) => ({ ...prev, [plantId]: false }))
      })
  }

  const datePickerStyle = {
    width: '140px',
    marginRight: '8px',
  }

  const userType = localStorage.getItem('userType')

  //pagination calculations
  const indexOfLastRow = currentPage * rowsPerPage
  const indexOfFirstRow = indexOfLastRow - rowsPerPage
  const currentRows = plantlist?.slice(indexOfFirstRow, indexOfLastRow) || []
  const totalPages = Math.ceil(plantlist?.length / rowsPerPage)


  return (
    <div className={classes.root} id="solar_plant_list">
      <Box
        ref={headerRef}
        sx={{ '& .MuiTextField-root': { m: 1, width: '100%' } }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <div className="solar_search_button">
              <div className="align_start" style={{ height: '48px' }}>
                <div className="w80">
                  <div className="searchbar">
                    <TextField
                      placeholder="Search..."
                      disableUnderline
                      onChange={handleSearch}
                      InputProps={{
                        disableUnderline: true,
                        endAdornment: (
                          <InputAdornment position="start" className="pointer">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={8}>
            <div className="align_end wrap">
              <div className="mr_8">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div style={datePickerStyle}>
                    <DatePicker
                      style={{
                        width: '100px !important',
                        height: '48px !important',
                      }}
                      className={classes.datePicker}
                      format="DD-MM-YYYY"
                      maxDate={dayjs()}
                      value={sortDate}
                      onChange={(value) => handleChangeDate(value)}
                    />
                  </div>
                </LocalizationProvider>
              </div>
              {(userType === 'admin' || userType === 'sub_admin') && (
                <>
                  <div
                    className="solar_list_h_button mr_8"
                    onClick={handleADDdevice}
                  >
                    Device List
                  </div>
                  <div
                    className="solar_list_h_button mr_8"
                    onClick={handlePlantreport}
                  >
                    Reports{' '}
                  </div>
                </>
              )}
              {(userType === 'admin' || userType === 'sub_admin') && (
                <div
                  className="solar_list_h_button mr_8"
                  onClick={handleAddnewplant}
                >
                  Add New Plant
                </div>
              )}
              <div>
                <select
                  className="selectbox mr_8"
                  value={selectedValue}
                  onChange={handleSelectChange}
                >
                  <option value="">Plant Type</option>
                  <option value="Capex">Capex</option>
                  <option value="Opex">Opex</option>
                </select>
              </div>
              {(userType === 'admin' || userType === 'sub_admin') && (
                <div className="map_list_toggle" onClick={handleSolarMapView}>
                  <label className="switch">
                    <input type="checkbox" />
                    <span className="slider"></span>
                  </label>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </Box>
      {Loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: `${screenHeight - headerHeight}px`,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
        <TableContainer
          className="main_table"
          component={Paper}
          sx={{
            height: 'auto',
            overflowY: 'auto',
          }}
        >
          <Table aria-label="collapsible table">
            <TableHead
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                backgroundColor: '#fff',
              }}
            >
              <TableRow>
                <TableCell scope="col" />
                <TableCell align="left" scope="col">
                  Plant Name
                </TableCell>
                <TableCell align="left" scope="col">
                  Code
                </TableCell>
                <TableCell align="left" scope="col">
                  Plant Location
                </TableCell>
                <TableCell
                  align="center"
                  scope="col"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  Plant Size (kWp)
                  <IconButton
                    style={{ width: '10px', height: '10px' }}
                    onClick={HandleSortPlant}
                  >
                    <ImportExportIcon className="sort_i" />
                  </IconButton>
                </TableCell>
                <TableCell align="center" scope="col">
                  Daily Energy (MFM)
                </TableCell>
                <TableCell align="center" scope="col">
                  E. Today (Inverter)
                </TableCell>
                <TableCell align="center" scope="col">
                  Yield (kWh/kWp)
                </TableCell>
                <TableCell align="center" scope="col">
                  GTI (kWh/m<sup>2</sup>)
                </TableCell>
                <TableCell align="center" scope="col">
                  PR (%)
                </TableCell>
                <TableCell align="center" scope="col">
                  CUF (%)
                </TableCell>
                <TableCell align="center" scope="col">
                  Grid Status
                </TableCell>
                <TableCell align="center" scope="col">
                  Device Status
                </TableCell>
                <TableCell align="center" scope="col">
                  Issues
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentRows?.map((row, index) => (
                <Row
                  key={row.name || index}
                  row={row}
                  onClick={() => handleTechnicalView(row)}
                  updateDeviceStatus={() => updateDeviceStatus(row?.id)}
                  deviceStatus={deviceStatus}
                  deviceStatusLoading={deviceStatusLoading}
                  issueCounts={issueCounts}
                  handleViewIssues={handleViewIssues}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ width: '100%' }}>
          <div className="pagination-controls" style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            padding: '16px',
            marginTop: '8px'
          }}>
            <div>
              <span>Rows per page: </span>
              <select 
                value={rowsPerPage} 
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value))
                  setCurrentPage(1)
                }}
                style={{ 
                  marginRight: '16px'
                }}
              >
                {[5, 10, 15, 25, 50].map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </div>
            
            <div>
              <span>
                {indexOfFirstRow + 1}-{Math.min(indexOfLastRow, plantlist?.length || 0)} of {plantlist?.length || 0}
              </span>
              
              <IconButton 
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                <KeyboardArrowLeftIcon />
              </IconButton>
              
              <IconButton 
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages || totalPages === 0}
              >
                <KeyboardArrowRightIcon />
              </IconButton>
            </div>
          </div>
        </Box>
      </>
      )}
    </div>    
  )
}

SolarPlantList.propTypes = {}

export default SolarPlantList